//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    computed: {
        token() {
            return this.$store.state.token;
        },
        userInfo() {
            return this.$store.state.userInfo;
        }
    },
    watch: {
        token(newVal) {
            if (newVal) {
                this.getOrderNum();
            } else {
                this.carBadge = {
                    receivWaiting: 0,
                    shipWaiting: 0,
                    payWaiting: 0,
                    afterSale: 0
                };
            }
        }
    },
    data() {
        return {
            carBadge: {
                receivWaiting: 0,
                shipWaiting: 0,
                payWaiting: 0,
                afterSale: 0
            },
            fromLBApp: sessionStorage.fromLBApp
        };
    },
    methods: {
        doRefresh(done) {
            this.getOrderNum();
            setTimeout(() => {
                done && done(true);
            }, 1000);
        },
        //获取订单数量
        getOrderNum() {
            let that = this;
            that.$axios
                .get('/api/v1.0/lonbonShop/orderNum', {
                    params: {
                        shopperId: that.userInfo.shopperId
                    }
                })
                .then(function(response) {
                    if (response.status == 200) {
                        that.carBadge = response.body;
                    }
                });
        },
        //退出登录
        logout() {
            let that = this;
            that.$vux.confirm.show({
                content: `是否确认退出登录？`,
                cancelText: '取消',
                confirmText: '确认',
                title: '提示',
                onConfirm() {
                    that.$store.state.token = null;
                    that.$store.state.userInfo = that.userInfo = {
                        poster: '',
                        displayName: ''
                    };
                    // 关闭websocket连接
                    that.$store.state.APPPAGE.resetWebsocket();
                }
            });
        }
    },
    mounted() {
        this.getOrderNum();
    }
};



// WEBPACK FOOTER //
// ./src/components/mine/index.vue